import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { Tab, Tabs } from "@blueprintjs/core";
import { wrapDialog } from "@teselagen/ui";
const highlightStyle = {
  background: "red",
  marginTop: 2
};
export const AutoAnnotateBpMatchingDialog = wrapDialog({
  title: "Annotation Matching"
})(function({ isRegex }) {
  return /* @__PURE__ */ jsx("div", { className: "bp3-dialog-body", children: /* @__PURE__ */ jsxs(Tabs, { defaultSelectedTabId: isRegex ? "regex" : "iupac", children: [
    /* @__PURE__ */ jsx(
      Tab,
      {
        id: "iupac",
        title: "IUPAC",
        panel: /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("p", { children: "When in standard (IUPAC) mode, annotations are matched case-insensitively. You can use any degenerate IUPAC base pair as well as a couple special characters." }),
          /* @__PURE__ */ jsx("h4", { children: "Special Characters:" }),
          /* @__PURE__ */ jsxs(
            "div",
            {
              style: {
                display: "grid",
                columnGap: 20,
                gridTemplateColumns: "1fr 5fr",
                maxHeight: 200,
                overflow: "auto"
              },
              children: [
                /* @__PURE__ */ jsx("div", { children: "#" }),
                /* @__PURE__ */ jsx("div", { children: "Any arbitrary string of zero or more bases can be matched here." }),
                /* @__PURE__ */ jsx("div", { children: "<" }),
                /* @__PURE__ */ jsxs("div", { children: [
                  "Any bases before a ",
                  "<",
                  " are considered optional"
                ] }),
                /* @__PURE__ */ jsx("div", { children: ">" }),
                /* @__PURE__ */ jsxs("div", { children: [
                  "Any bases after a ",
                  ">",
                  " are considered optional"
                ] }),
                /* @__PURE__ */ jsx("div", { children: "M" }),
                " ",
                /* @__PURE__ */ jsx("div", { children: "AC" }),
                /* @__PURE__ */ jsx("div", { children: "R" }),
                " ",
                /* @__PURE__ */ jsx("div", { children: "AG" }),
                /* @__PURE__ */ jsx("div", { children: "W" }),
                " ",
                /* @__PURE__ */ jsx("div", { children: "AT" }),
                /* @__PURE__ */ jsx("div", { children: "S" }),
                " ",
                /* @__PURE__ */ jsx("div", { children: "CG" }),
                /* @__PURE__ */ jsx("div", { children: "Y" }),
                " ",
                /* @__PURE__ */ jsx("div", { children: "CT" }),
                /* @__PURE__ */ jsx("div", { children: "K" }),
                " ",
                /* @__PURE__ */ jsx("div", { children: "GT" }),
                /* @__PURE__ */ jsx("div", { children: "V" }),
                " ",
                /* @__PURE__ */ jsx("div", { children: "ACG" }),
                /* @__PURE__ */ jsx("div", { children: "H" }),
                " ",
                /* @__PURE__ */ jsx("div", { children: "ACT" }),
                /* @__PURE__ */ jsx("div", { children: "D" }),
                " ",
                /* @__PURE__ */ jsx("div", { children: "AGT" }),
                /* @__PURE__ */ jsx("div", { children: "B" }),
                " ",
                /* @__PURE__ */ jsx("div", { children: "CGT" }),
                /* @__PURE__ */ jsx("div", { children: "X" }),
                " ",
                /* @__PURE__ */ jsx("div", { children: "GATC" }),
                /* @__PURE__ */ jsx("div", { children: "N" }),
                " ",
                /* @__PURE__ */ jsx("div", { children: "GATC" }),
                /* @__PURE__ */ jsx("div", { children: "." }),
                " ",
                /* @__PURE__ */ jsx("div", { children: "GATC" })
              ]
            }
          ),
          /* @__PURE__ */ jsx("br", {}),
          /* @__PURE__ */ jsx("h4", { children: "Examples:" }),
          /* @__PURE__ */ jsxs(
            "div",
            {
              style: {
                display: "grid",
                columnGap: 20,
                gridTemplateColumns: "2fr 5fr"
              },
              children: [
                /* @__PURE__ */ jsx("h6", { children: "Annotation" }),
                /* @__PURE__ */ jsxs("h6", { children: [
                  "Sequence (matches in ",
                  /* @__PURE__ */ jsx("span", { style: highlightStyle, children: "red" }),
                  ")"
                ] }),
                /* @__PURE__ */ jsx("div", { children: "AATT" }),
                /* @__PURE__ */ jsxs("div", { children: [
                  "AA",
                  /* @__PURE__ */ jsx("span", { style: highlightStyle, children: "AATT" }),
                  "TTGGGGGCCCCCAAGT"
                ] }),
                /* @__PURE__ */ jsx("div", { children: "aAkT" }),
                /* @__PURE__ */ jsxs("div", { children: [
                  "AA",
                  /* @__PURE__ */ jsx("span", { style: highlightStyle, children: "AATT" }),
                  "TTGGGGGCCCCC",
                  /* @__PURE__ */ jsx("span", { style: highlightStyle, children: "AAGT" })
                ] }),
                /* @__PURE__ */ jsx("div", { children: "ANT" }),
                /* @__PURE__ */ jsxs("div", { children: [
                  "AA",
                  /* @__PURE__ */ jsx("span", { style: highlightStyle, children: "AAT" }),
                  "TTTGGGGGCCCCCA",
                  /* @__PURE__ */ jsx("span", { style: highlightStyle, children: "AGT" })
                ] }),
                /* @__PURE__ */ jsx("div", { children: "T#C" }),
                /* @__PURE__ */ jsxs("div", { children: [
                  "AAAATTT",
                  /* @__PURE__ */ jsx("span", { style: highlightStyle, children: "TGGGGGC" }),
                  "CCCCAAGT"
                ] }),
                /* @__PURE__ */ jsxs("div", { children: [
                  "CA",
                  "<",
                  "ATTT"
                ] }),
                /* @__PURE__ */ jsxs("div", { children: [
                  "AA",
                  /* @__PURE__ */ jsx("span", { style: highlightStyle, children: "AATTT" }),
                  "TGGGGGCCCCCAAGT"
                ] }),
                /* @__PURE__ */ jsxs("div", { children: [
                  "CA",
                  "<",
                  "ATT",
                  ">",
                  "TTGAG"
                ] }),
                /* @__PURE__ */ jsxs("div", { children: [
                  "AA",
                  /* @__PURE__ */ jsx("span", { style: highlightStyle, children: "AATTTTG" }),
                  "GGGGCCCCCAAGT"
                ] })
              ]
            }
          ),
          /* @__PURE__ */ jsx("br", {})
        ] })
      }
    ),
    /* @__PURE__ */ jsx(
      Tab,
      {
        id: "regex",
        title: "Regex",
        panel: /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("p", { children: "When in regex mode, you can use any custom regex to match base pairs" }),
          /* @__PURE__ */ jsxs("p", { children: [
            "You can learn more and try out your custom regexes at",
            " ",
            /* @__PURE__ */ jsx("a", { href: "https://regex101.com/", children: "https://regex101.com/" })
          ] }),
          /* @__PURE__ */ jsx("br", {}),
          /* @__PURE__ */ jsx("h4", { children: "Examples:" }),
          /* @__PURE__ */ jsxs(
            "div",
            {
              style: {
                display: "grid",
                columnGap: 20,
                gridTemplateColumns: "2fr 5fr"
              },
              children: [
                /* @__PURE__ */ jsx("h6", { children: "Annotation" }),
                /* @__PURE__ */ jsxs("h6", { children: [
                  "Sequence (matches in ",
                  /* @__PURE__ */ jsx("span", { style: highlightStyle, children: "red" }),
                  ")"
                ] }),
                /* @__PURE__ */ jsx("div", { children: "AATT" }),
                /* @__PURE__ */ jsxs("div", { children: [
                  "AA",
                  /* @__PURE__ */ jsx("span", { style: highlightStyle, children: "AATT" }),
                  "TTGGGGGCCCCCAAGT"
                ] }),
                /* @__PURE__ */ jsx("div", { children: "aAtT" }),
                /* @__PURE__ */ jsxs("div", { children: [
                  "AA",
                  /* @__PURE__ */ jsx("span", { style: highlightStyle, children: "AATT" }),
                  "TTGGGGGCCCCCAAGT"
                ] }),
                /* @__PURE__ */ jsx("div", { children: "A.T" }),
                /* @__PURE__ */ jsxs("div", { children: [
                  "AA",
                  /* @__PURE__ */ jsx("span", { style: highlightStyle, children: "AAT" }),
                  "TTTGGGGGCCCCCA",
                  /* @__PURE__ */ jsx("span", { style: highlightStyle, children: "AGT" })
                ] }),
                /* @__PURE__ */ jsx("div", { children: "T.*C" }),
                /* @__PURE__ */ jsxs("div", { children: [
                  "AAAA",
                  /* @__PURE__ */ jsx("span", { style: highlightStyle, children: "TTTTGGGGGCCCCC" }),
                  "AAGT"
                ] }),
                /* @__PURE__ */ jsx("div", { children: "T[^T]*?C" }),
                /* @__PURE__ */ jsxs("div", { children: [
                  "AAAATTT",
                  /* @__PURE__ */ jsx("span", { style: highlightStyle, children: "TGGGGGC" }),
                  "CCCCAAGT"
                ] }),
                /* @__PURE__ */ jsx("div", { children: "C?A?ATT" }),
                /* @__PURE__ */ jsxs("div", { children: [
                  "AA",
                  /* @__PURE__ */ jsx("span", { style: highlightStyle, children: "AATTT" }),
                  "TGGGGGCCCCCAAGT"
                ] }),
                /* @__PURE__ */ jsx("div", { children: "C?A?ATTT?T?C?" }),
                /* @__PURE__ */ jsxs("div", { children: [
                  "AA",
                  /* @__PURE__ */ jsx("span", { style: highlightStyle, children: "AATTTT" }),
                  "GGGGGCCCCCAAGT"
                ] })
              ]
            }
          ),
          /* @__PURE__ */ jsx("br", {})
        ] })
      }
    )
  ] }) });
});
